export function getUser (state) {
    return function() { return state.user };
}
